export default "__VITE_ASSET__sLGeH8Qp__"